import React, { useEffect } from "react";
import Landhead from "./Landhead";
import Copyrights from "../components/Copyrights";
import Notification from "./Notification";
import Landingslides from "./Landingslides";
import Startorder from "./Startorder";
import { useAuth } from "../hooks/customers/AuthProvider";
import * as Config from "../config/config";

function Landing() { 

const auth = useAuth();
const customer = auth?.customer;

useEffect(() => {
    // Add the class to the body
    document.body.classList.add("header_remove"); 
    document.body.classList.add("landingheaderadd"); 

    // Cleanup function to remove the class when the component is unmounted
    return () => {
      document.body.classList.remove("header_remove");
      document.body.classList.remove("landingheaderadd"); 
    };
  }, []);

  return (
        <div className="global_container_ global_landpage">
            <Landhead />
            <div className="innerwrapper pagelanding pagelandingitems">
              <div className="pagelanding_l">
                    <Notification />
                    <Landingslides />
              </div>
              {customer?.role != Config.DISTRICT_MANAGER_ROLE && (
              <Startorder />
              )}
            </div>
            <Copyrights />
            
        </div>


    );
}

export default Landing;
